import { useTravelataApiService } from '@/shared/composables/useTravelataApiService';
import { useTravelataAppConfig } from '@/shared/composables/useTravelataAppConfig';
import type { ActiveLottery, ActiveLotteryResponse } from './types';

const ENDPOINT = '/frontend/lotteries/active';

export async function getActiveLottery(): Promise<ActiveLottery | null> {
  try {
    const apiService = useTravelataApiService();
    const config = useTravelataAppConfig();
    const response = await apiService.get<ActiveLotteryResponse>(`${config.apiGatewayUrl}${ENDPOINT}?isMobile=true`);

    if (response?.success !== true) return null;

    return response.result ?? null;
  } catch {
    return null;
  }
}
